<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title>{{'従業員新規登録'}}</v-card-title>
        <form>
          <v-flex sm12>
            <v-text-field v-model="userId" v-validate="'required|max:20'" :counter="20" :error-messages="errors.collect('userId')" data-vv-name="userId" required >
              <template v-slot:label>
                <span class="required-star">*</span> 従業員ID
              </template>            
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="lastName" v-validate="'required|max:60'" :counter="60" :error-messages="errors.collect('lastName')" data-vv-name="lastName" required >
              <template v-slot:label>
                <span class="required-star">*</span> 名前(JP)
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="firstName" label="名前(EN)" v-validate="'required|max:60'" :counter="60"  
              data-vv-name="firstName"></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingSex"
              :items="sexItems"
              item-text="sexName"
              item-value="sexCode"              
              return-object
              required
            >
            <template v-slot:label>
              <span class="required-star">*</span> 性別
            </template>
          </v-select>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="country" v-validate="'required|max:60'" :counter="60" :error-messages="errors.collect('country')" data-vv-name="country" required >
              <template v-slot:label>
                <span class="required-star">*</span> 勤務地(Country)
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="city" v-validate="'required|max:60'" :counter="60" :error-messages="errors.collect('city')" data-vv-name="city" required >
              <template v-slot:label>
                <span class="required-star">*</span> 勤務地(City)
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingDepth"
              :items="depthItems"
              item-text="depthName"
              item-value="depthCode"
              label="部署"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingTeam"
              :items="teamItems"
              item-text="teamName"
              item-value="teamCode"
              label="課"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingTeamDetail"
              :items="teamDetailItems"
              item-text="teamDetailName"
              item-value="teamDetailCode"
              label="Group"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingStaffType"
              :items="staffTypeItems"
              item-text="staffTypeName"
              item-value="staffTypeCode"
              return-object
              required
            >
              <template v-slot:label>
                <span class="required-star">*</span> 契約種類
              </template>
            </v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingAdminRole"
              :items="adminRoleItems"
              item-text="adminRoleName"
              item-value="adminRoleCode"              
              return-object
              required
            >
              <template v-slot:label>
                <span class="required-star">*</span> システム権限
              </template>
            </v-select>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="mailAddress" label="e-mail" v-validate="'required|max:60'" :counter="60" data-vv-name="mailAddress" ></v-text-field>
          </v-flex>

          <div style="height: 55px;"></div>
          <v-layout row wrap justify-space-between>
            <v-flex xs8 sm4 align-self-center>
              <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-user-upload' }">
                <v-icon dark left>arrow_back</v-icon>戻る
              </v-btn>
            </v-flex>

            <v-flex xs8 sm4 align-self-center>
              <v-btn block color="success" dark @click="newUser()" >
                <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>save</v-icon>
                {{ '登録' }}する
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-container>
    </v-card>    
  </v-container>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import { VMoney } from 'v-money'

Vue.use(VeeValidate)

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
  },
  methods: {
    newUser() {
      let thisObj = this
      thisObj.loading2 = true

      if (this.userId == "") {
        alert("従業員IDを入力してください")
        return
      }
      if (this.lastName == "") {
        alert("名前(JP)を入力してください")
        return
      }
      if (this.editingSex.sexCode == "") {
        alert("性別を選択してください")
        return
      }
      if (this.country == "") {
        alert("勤務地(Country)を入力してください")
        return
      }
      if (this.city == "") {
        alert("勤務地(City)を入力してください")
        return
      }
      if (this.editingStaffType.staffTypeCode == "") {
        alert("契約種類を選択してください")
        return
      }
      if (this.editingAdminRole.adminRoleCode == "") {
        alert("システム権限を選択してください")
        return
      }

      let request = {
        userId: this.userId,
        lastName: this.lastName,
        firstName: this.firstName,
        sex: this.editingSex.sexName,
        country: this.country,
        city: this.city,
        userGroup: this.editingDepth.depthName,
        userGroup2: this.editingTeam.teamName,
        userGroup3: this.editingTeamDetail.teamDetailName,
        staffType: this.editingStaffType.staffTypeName,
        adminRole: this.editingAdminRole.adminRoleCode, // 권한만 기존의 코드로 등록한다다
        mailAddress: this.mailAddress
      }
      
      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-user-upload',
      }

      // this.$validator.validateAll().then((result) => {
      //   if (!result) {
      //     this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
      //     thisObj.loading2 = false
      //     return
      //   }

      //   ServerApiCallService.userPost(request, sendContext)
      //     .then(() => {
      //       console.log('completed new item')
      //       thisObj.loading2 = false
      //     })
      //     .catch((error) => {
      //       console.log('There was an error:', error.response)
      //     })
      // })

      ServerApiCallService.userPost(request, sendContext)
        .then(() => {
          console.log('completed new item')
          thisObj.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })
    }
  },
  data() {
    return {
      loading: true,
      loading2: false,

      userId: '',
      lastName: '',
      firstName: '',
      country: '',
      city: '',
      mailAddress: '',
      editingSex: {
        sexName: '',
        sexCode: ''
      },
      editingTeam: {
        teamName: '',
        teamCode: ''
      },
      editingTeamDetail: {
        teamDetailName: '',
        teamDetailCode: ''
      },
      editingDepth: {
        depthName: '',
        depthCode: ''
      },
      editingStaffType: {
        staffTypeName: '',
        staffTypeCode: ''
      },
      editingAdminRole: {
        adminRoleName: '',
        adminRoleCode: ''
      },
      sexItems: [
        {
          sexName: '男',
          sexCode: '0'
        },
        {
          sexName: '女',
          sexCode: '1'
        }
      ],      
      teamItems: [
        {
          teamName: '',
          teamCode: '0'
        },
        {
          teamName: '営業サポート',
          teamCode: '1'
        },
        {
          teamName: '新規事業開発課',
          teamCode: '2'
        },
        {
          teamName: '営業課',
          teamCode: '3'
        },
        {
          teamName: '店舗課',
          teamCode: '4'
        },
        {
          teamName: 'システム管理',
          teamCode: '5'
        },
        {
          teamName: 'デザイン管理',
          teamCode: '6'
        }
      ],      
      teamDetailItems: [
      {
          teamDetailName: '',
          teamDetailCode: '0'
        },
        {
          teamDetailName: '東京',
          teamDetailCode: '1'
        },
        {
          teamDetailName: '大阪',
          teamDetailCode: '2'
        },
        {
          teamDetailName: '京都',
          teamDetailCode: '3'
        },
        {
          teamDetailName: '沖縄',
          teamDetailCode: '4'
        },
        {
          teamDetailName: '札幌',
          teamDetailCode: '5'
        }
      ],      
      depthItems: [
        {
          depthName: '',
          depthCode: '0'
        },
        {
          depthName: '免税ビジネス部',
          depthCode: '1'
        },
        {
          depthName: '店舗営業サポート部',
          depthCode: '2'
        },
        {
          depthName: '国内営業部',
          depthCode: '3'
        },
        {
          depthName: '国際営業部',
          depthCode: '4'
        },
        {
          depthName: '業務管理部',
          depthCode: '5'
        },
        {
          depthName: '人事総務部',
          depthCode: '6'
        },
        {
          depthName: '広告部',
          depthCode: '7'
        },
        {
          depthName: 'システムデザイン部',
          depthCode: '8'
        },
        {
          depthName: '商品企画開発部',
          depthCode: '9'
        },
        {
          depthName: '物流部',
          depthCode: '10'
        },
        {
          depthName: '業務推進部',
          depthCode: '11'
        }
      ],      
      staffTypeItems: [
        {
          staffTypeName: '役員',
          staffTypeCode: '0'
        },
        {
          staffTypeName: '正社員',
          staffTypeCode: '1'
        },
        {
          staffTypeName: '契約社員',
          staffTypeCode: '2'
        },
        {
          staffTypeName: 'アルバイト',
          staffTypeCode: '3'
        },
        {
          staffTypeName: 'その他',
          staffTypeCode: '4'
        }
      ],      
      adminRoleItems: [
        {
          adminRoleName: '一般社員(販売員)',
          adminRoleCode: '0'
        },
        {
          adminRoleName: '人事管理者',
          adminRoleCode: '1'
        },
        {
          adminRoleName: '本部担当者',
          adminRoleCode: '2'
        },
        {
          adminRoleName: '発注確認者',
          adminRoleCode: '3'
        },
        {
          adminRoleName: 'ZUMI',
          adminRoleCode: '9'
        }
      ],
    }
  },
  $_veeValidate: {
    validator: 'new',
  }
}
</script>

<style>
.required-star {
  color: red;
  margin-right: 4px;
}
</style>

